import type { ReactNode } from 'react';
import { Navigate } from '@tanstack/react-router';
import { useFeatureFlag } from '@org/ui';
import type { FeatureFlagKey } from '@org/model';

/**
 * Route guard for flag-gated pages. Renders nothing while the flag is being
 * resolved so users without the flag never see a flash of gated content.
 */
export function FeatureFlagGate({
  flag,
  children,
}: {
  flag: FeatureFlagKey;
  children: ReactNode;
}) {
  const { isEnabled, isLoading } = useFeatureFlag(flag);

  if (isLoading) {
    return null;
  }
  if (!isEnabled) {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
}
